module.exports = __webpack_public_path__ + "assets/img/magnifying.1fe2a77b.svg";